import { create } from 'zustand';

/**
 * Drives the app-wide command palette (⌘K / Ctrl+K). Two producers open it:
 * the global keydown listener in `CommandPalette.tsx` and the sidebar's
 * search trigger button. Ephemeral — NOT persisted, unlike `useUiStore`; a
 * reload should never reopen the palette.
 */
export interface CommandPaletteState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  setOpen: (next: boolean) => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  setOpen: (next) => set({ isOpen: next }),
}));
